module.exports = __webpack_public_path__ + "static/media/algo.90c15fde.png";